import script from "./DocHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DocHeader.vue?vue&type=script&setup=true&lang=js"

import "./DocHeader.vue?vue&type=style&index=0&id=13065e41&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13065e41"]])

export default __exports__